<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card class="rounded">
        <v-card-title class="mb-0">
          <h4 class="subheading ml-1">Accept Invitations</h4>
        </v-card-title>
        <v-card-text>
          <v-list dense two-line>
            <div v-if="componentState === 'loading'" class="pa-2 mb-2">
              <v-progress-linear
                color="#d13b55"
                height="2"
                :indeterminate="true"
              ></v-progress-linear>
            </div>
            <div
              v-if="
                componentState == 'loaded' || componentState == 'workinprogress'
              "
            >
              <div v-if="myinvites.length < 1" class="pa-2">
                <span>
                  You don't currently have any pending invites. If you are
                  expecting an invite, check with your organization admin to
                  ensure
                  <em class="font-weight-bold">{{
                    ($store.state.userSelf.profile || {}).email
                  }}</em>
                  is the email address that was invited.
                </span>
              </div>
              <div else v-for="(myinvite, index) in myinvites" :key="index">
                <v-list-tile avatar ripple class="rounded">
                  <v-list-tile-avatar>
                    <v-icon>mdi-office-building</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title
                      ><span class="font-weight-bold">{{
                        myinvite.orgName
                      }}</span></v-list-tile-title
                    >
                    <v-list-tile-sub-title
                      >{{ myinvite.name }}:
                      {{ myinvite.invitationMessage }}</v-list-tile-sub-title
                    >
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn
                      class="btn-rounded-medium white--text"
                      small
                      color="#d13b55"
                      @click.prevent="clickmyinvite(myinvite)"
                      :disabled="componentState == 'workinprogress'"
                    >
                      Accept
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider
                  v-if="index + 1 < myinvites.length"
                  :key="index + 1 + myinvites.length"
                ></v-divider>
              </div>
            </div>
          </v-list>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  name: "InvitesFromOrganizations",
  data() {
    return {
      componentState: "loading", // loading, loaded
    };
  },
  methods: {
    clickmyinvite: function (invite) {
      this.componentState = "workinprogress";

      // Display Message
      this.$store.commit("replaceSnackbar", {
        message: "Accepting organization invite...",
        messageType: "warning",
      });

      const params = { subdomain: invite.subdomain, email: invite.email };

      axios
        .post("/api/user/acceptinvite", params, this.$store.state.axiosConfig)
        .then((response) => {
          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message: "Invite Successfully Accepted.",
          });

          // Commit user info to global
          this.$store.commit("setUserSelf", response.data.user);

          // User profile may have be complete - dispatch for potential update to global flag
          this.$store.commit("refreshUserProfileIsComplete");
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Invite was NOT accept.<br>Response: " +
              e.response.data.message +
              "<br>Error #BUI378",
            messageType: "error",
          });
        });
    },
  },
  computed: {
    myinvites() {
      // get the pending invites or return an empty array (to keep for loop in above template from erroring out)
      return this.$store.state.userSelf.pendingInvites || [];
    },
  },
  beforeMount() {
    axios
      .get("/api/user/self", this.$store.state.axiosConfig)
      .then((response) => {
        // Commit user info to global
        this.$store.commit("setUserSelf", response.data.user);

        this.componentState = "loaded";
      })
      .catch((e) => {
        // check/ handle 401 (Unauthorized) error
        this.$store.dispatch("error401Response", e);

        // Display Error Message
        this.$store.commit("replaceSnackbar", {
          message:
            "Error. My Invites.<br>Response: " +
            e.response.data.message +
            "<br>Error #NDI832",
          messageType: "error",
        });
      });
  },
};
</script>
